<template>
    <div class="mode" @click="selectEvent">
        <div class="iconDiv" :style="{background:isSelect?'#F97D2B':'#77CBFF'}">
            <i class="iconfont" :class="iconName"></i>
        </div>
        <div class="title">
            {{title}}
        </div>
    </div>
</template>

<script>
export default {
    props:['iconName','title','isSelect'],
    data(){
        return{

        }
    },
    methods:{
        // 选中事件
        selectEvent(){
            this.$emit('selectEvent')
        }
    }

}
</script>

<style lang="scss" scoped>
    .mode{
        display:flex;
        flex-direction: column;
        height: 100%;
        width: 80px;
        justify-content: center;
        align-items: center;
    }
    .iconDiv{
        width: 30px;
        width: 30px;
        border-radius: 30px;
        display: flex;
        justify-content: center;
        align-items: center;
    }
    .title{
        color: #fff;
        font-size: 14px;
    }
    .iconfont{
        font-size: 18px;
        color: #fff;
    }

</style>


// WEBPACK FOOTER //
// src/components/topMode.vue